module.exports = __webpack_public_path__ + "assets/images/profiles/1970-4-desktop.jpg?v=f6caeef3";